'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Utils


// Constants


var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _authService = require('../auth/authService');

var _userConstants = require('../../common/users/userConstants');

var _currentUserConstants = require('./currentUserConstants');

var _elementConstants = require('../../common/elements/elementConstants');

var _authConstants = require('../auth/authConstants');

var _notificationConstants = require('../../common/notifications/notificationConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.Map({
    _id: 'guest',
    // TODO This might be erroneous, maybe it needs to be set during bootstrap
    // It causes the initial state object to forever be what it was when the app loaded
    isGuest: !(0, _authService.getCurrentUserToken)(),
    authenticated: false,
    fetched: false,
    clientId: 'NULLID',
    clientTick: 0,
    viewedBoards: Immutable.Map()
});

var updateCurrentUserDetails = function updateCurrentUserDetails(state, action) {
    if (action.userId !== state.get('_id')) return state;

    var userChanges = Immutable.fromJS(action.changes);
    return state.mergeDeep(userChanges);
};

var updateViewedBoards = function updateViewedBoards(state, viewedBoardIds, timestamp) {
    return state.update('viewedBoards', function (viewedBoards) {
        var updatedBoards = viewedBoards;
        viewedBoardIds.forEach(function (id) {
            updatedBoards = updatedBoards.set(id, timestamp);
        });
        return updatedBoards;
    });
};

var setUserImageData = function setUserImageData(state, action) {
    return state.setIn(['image', 'data'], action.imageData).setIn(['image', 'uploading'], true);
};

var setUserImageUploadComplete = function setUserImageUploadComplete(state, action) {
    return state.setIn(['image', 'uploading'], false);
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _userConstants.USER_UPDATE:
            return updateCurrentUserDetails(state, action);
        case _authConstants.LOGOUT:
            return initialState.set('isGuest', true);
        case _authConstants.REGISTER_SUCCESS:
        case _authConstants.LOGIN_SUCCESS:
            return state.set('isGuest', false);
        case _userConstants.USER_REFRESH:
        case _currentUserConstants.CURRENT_USER_SET:
            return Immutable.fromJS(_extends({}, action.user, {
                isGuest: false,
                authenticated: true,
                fetched: true,
                viewedBoards: {}
            }));
        case _elementConstants.ELEMENT_CREATE:
            return state.update('clientTick', function (tick) {
                return tick + 1;
            });
        case _userConstants.USER_NAVIGATE:
            return updateViewedBoards(state, [action.newBoardId, action.previousBoardId], action.timestamp);
        case _notificationConstants.MODIFIED_ELEMENTS_MARK_SEEN:
            return updateViewedBoards(state, action.ids, action.timestamp);
        case _currentUserConstants.CURRENT_USER_IMAGE_SET:
            return setUserImageData(state, action);
        // TODO Image error handling
        case _currentUserConstants.CURRENT_USER_IMAGE_UPLOAD_ERROR:
        case _currentUserConstants.CURRENT_USER_IMAGE_UPLOAD_COMPLETE:
            return setUserImageUploadComplete(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/currentUserReducer.js
// module id = 2108
// module chunks = 0